export default "__VITE_ASSET__94a39472__"